export default __webpack_public_path__ + "static/media/link-solid.87495b7f.svg";